export const generateEmbroideryId = ()=>`embroidery_${Date.now()}_${Math.floor(Math.random() * 100000)}`;
